
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Cookie utility functions
export const cookieUtils = {
  // Set a cookie with expiration
  set: (name, value, days = 7) => {
    try {
      const cookieValue = JSON.stringify(value);
      
      // Try setting without expiration first (session cookie)
      const sessionCookieString = `${name}=${cookieValue}; path=/`;
      document.cookie = sessionCookieString;
      
      // Check if session cookie works
      setTimeout(() => {
        const sessionCheck = document.cookie.includes(`${name}=`);
        
        if (sessionCheck) {
          // If session cookie works, try with expiration
          const expires = new Date();
          expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
          const persistentCookieString = `${name}=${cookieValue}; expires=${expires.toUTCString()}; path=/`;
          
          
          document.cookie = persistentCookieString;
          
          setTimeout(() => {
            const finalCheck = document.cookie.includes(`${name}=`);
          }, 200);
        } else {
          console.error('❌ Even session cookie failed - there may be a browser/domain issue');
        }
      }, 200);
      
      // Check if cookie value is too large
      if (cookieValue.length > 4000) {
        console.warn('⚠️ Cookie value is very large:', cookieValue.length, 'characters');
      }
      
    } catch (error) {
      console.error('❌ Error setting cookie:', error);
    }
  },

  // Get a cookie value
  get: (name) => {
    try {
      const nameEQ = name + "=";
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) {
          try {
            const value = c.substring(nameEQ.length, c.length);
            return JSON.parse(value);
          } catch (e) {
            console.warn('🍪 Failed to parse cookie JSON:', e);
            return c.substring(nameEQ.length, c.length);
          }
        }
      }
      return null;
    } catch (error) {
      console.error('❌ Error getting cookie:', error);
      return null;
    }
  },

  // Delete a cookie
  delete: (name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  },

  // Check if a cookie exists
  exists: (name) => {
    return cookieUtils.get(name) !== null;
  },

  // Test function to verify cookies are working
  test: () => {
    const testName = 'cookie_test';
    const testValue = { test: 'data', timestamp: Date.now() };
    
    
    // Set test cookie
    cookieUtils.set(testName, testValue, 1);
    
    // Try to get it back
    const retrieved = cookieUtils.get(testName);
    
    if (retrieved && retrieved.test === 'data') {
      cookieUtils.delete(testName); // Clean up
      return true;
    } else {
      console.error('❌ Cookie test failed');
      return false;
    }
  },

  // Debug function to list all cookies
  listAll: () => {
    const cookies = document.cookie.split(';').map(cookie => {
      const [name, ...valueParts] = cookie.trim().split('=');
      return { name, value: valueParts.join('=') };
    });
    console.table(cookies);
    return cookies;
  },

  // Debug function to check specific cookie
  debug: (name) => {
    const rawCookies = document.cookie;
    const cookieExists = rawCookies.includes(`${name}=`);
    const cookieValue = cookieUtils.get(name);
    
    
    return {
      exists: cookieExists,
      value: cookieValue,
      raw: rawCookies
    };
  },

  // Force refresh DevTools cookies view
  refreshDevTools: () => {
    // This is a hack to force DevTools to refresh the cookies view
    document.cookie = "devtools_refresh=1; path=/; max-age=1";
    setTimeout(() => {
      document.cookie = "devtools_refresh=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    }, 100);
  },

  // Simple cookie set without JSON (for testing)
  setSimple: (name, value) => {
    const cookieString = `${name}=${value}; path=/`;
    document.cookie = cookieString;
    
    setTimeout(() => {
      const check = document.cookie.includes(`${name}=`);
    }, 100);
  }
};

// Expose cookieUtils globally for debugging
if (typeof window !== 'undefined') {
  window.cookieUtils = cookieUtils;
}
